import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from 'components/button';
import { generatePath, useNavigate, useLocation } from 'react-router-dom';
import { useDocumentCompare } from 'store/document-compare';
import { RoutePath } from 'router/routes/routePath';

const SContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    height: ${({ theme }) => theme.height.navbar};
    padding: 0 24px;
    background-color: ${({ theme }) => theme.colors.golden_sand};
`;

const SWrapper = styled.div`
    display: flex;
    width: 100%;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
`;

const SCompareModeText = styled.p`
    font-size: ${({ theme }) => theme.font.size.medium};
    font-weight: ${({ theme }) => theme.font.weight.medium};

    strong {
        font-weight: ${({ theme }) => theme.font.weight.medium};
    }
`;

const SCompareModeHint = styled.span`
    font-size: ${({ theme }) => theme.font.size.small};
    font-weight: ${({ theme }) => theme.font.weight.normal};
    color: ${({ theme }) => theme.colors.gray_80};
`;

const SButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const SAbortButton = styled(Button)`
    padding: 8px 20px;
    background: ${({ theme }) => theme.colors.buff};
    font-size: ${({ theme }) => theme.font.size.medium};
    box-shadow: none;
`;

const SCompareButton = styled(Button)`
    padding: 8px 20px;
    background: ${({ theme }) => theme.colors.white};
    font-size: ${({ theme }) => theme.font.size.medium};
    box-shadow: none;
`;

export const CompareModeBar = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { isInCompareMode, firstFile, secondFile, exitCompareMode } = useDocumentCompare();

    const isOnCompareView = location.pathname.includes(RoutePath.DocumentCompare);

    if (!isInCompareMode) {
        return null;
    }

    const handleCompare = () => {
        if (firstFile && secondFile && !isOnCompareView) {
            navigate(generatePath(RoutePath.DocumentCompare));
        }
    };

    const handleCancel = () => {
        exitCompareMode();
        if (isOnCompareView) {
            navigate(-1);
        }
    };

    return (
        <SContainer>
            <SWrapper>
                <SCompareModeText>
                    <Trans
                        i18nKey={t('compare-mode.mode')}
                        components={{
                            bold: <strong />,
                            hint: <SCompareModeHint />,
                        }}
                    />
                </SCompareModeText>

                <SButtons>
                    <SAbortButton onClick={handleCancel}>{t('common.abort')}</SAbortButton>
                    {!isOnCompareView && firstFile && secondFile && (
                        <SCompareButton onClick={handleCompare}>
                            {t('compare-mode.compare-files')}
                        </SCompareButton>
                    )}
                </SButtons>
            </SWrapper>
        </SContainer>
    );
};
